<div class="container">
  <h1 class="mb-4">
    Open Standards
  </h1>
  <div>
    <div>
      The Aqaix API Platform is architected on the following standards:
    </div>

    <h2 class="mt-4">
      REST
    </h2>
    <div>
      The modern standard for efficient, secure APIs.
    </div>

    <h2 class="mt-4">
      OAuth 2.0
    </h2>
    <div>
      Robust security with a wide variety of implementation models, permitting many styles of usage yet with a centralized control point.
    </div>

    <h2 class="mt-4">
      JSON
    </h2>
    <div>
      The efficient response format. (You can also use XML but JSON is way better. <i class="fa fa-smiley"></i>)
    </div>

    <h2 class="mt-4">
      Swagger
    </h2>
    <div>
      The standard for API Documentation.
    </div>

    <h2 class="mt-4">
      OpenID Connect
    </h2>
    <div>
      Standard authentication for logging into the Aqaix tools, and exchange of API credentials.
    </div>

  </div>
</div>
